/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to true if you want to use the splash screen.
  useCustomCursor: true, // Change this to false if you want the good'ol cursor
  googleTrackingID: " ",
};

//Home Page
const greeting = {
  title: "Hello.",
  title2: "Harshil",
  logo_name: "harshil()",
  nickname: "harshil",
  full_name: "Harshil Shah",
  subTitle: "Full Stack Web Developer, Web3 Enthusiast. Always learning.",
  resumeLink:
    "https://drive.google.com/file/d/107QENlJOHWzrCXOq1kyrIBc_DE8gpUnz/view?usp=sharing",
  mail: "mailto:vharshil.mehta@gmail.com",
};

const socialMediaLinks = {
  /* Your Social Media Link */
  github: "https://github.com/harshilshah99",
  linkedin: "https://www.linkedin.com/in/harshil-shah-6776a221b/",
  gmail: "vharshil.mehta@gmail.com",
};

const skills = {
  data: [
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building responsive website front end using ReactJS and Angular",
        "⚡ Integrating websites with MongoDB and Supabase databases",
        "⚡ Backend development using NodeJS and ExpressJS",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#FFFFFF",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "Java",
          fontAwesomeClassname: "simple-icons:java",
          style: {
            color: "#f89820",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#439743",
          },
        },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "simple-icons:mysql",
          style: {
            color: "#4479A1",
          },
        },
        {
          skillName: "Git",
          fontAwesomeClassname: "simple-icons:git",
          style: {
            color: "#E94E32",
          },
        },
      ],
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Veermata Jijabai Technological Institute",
      subtitle: "B.Tech. in Computer Engineering",
      logo_path: "vjti.jpg",
      alt_name: "DAL",
      duration: "2020 - 2024",
      descriptions: [
        "⚡ Studied Advanced Software Development Concepts, Data Management & Warehousing",
        "⚡ Learn Advanced Topics in Cloud Computing, Cloud Architecture along with Serverless Computing",
        "⚡ Worked on projects on courses like Mobile Computing and Web Technologies.",
      ],
      website_link: "https://vjti.ac.in/",
    },
    {
      title: "S.V.P. Junior College of Science",
      subtitle: "12 th",
      logo_path: "svp.jpg",
      alt_name: "SETI",
      duration: "2018 - 2020",
      descriptions: [
        "⚡ I have studied core subjects like Data Structures, DBMS, Networking, Security, etc.",
        "⚡ I have also completed various online courses for ML/DL, Web Development, Mobile App Development, etc.",
        "⚡ I have implemented several projects based on what I've learnt under my Computer Engineering course. ",
      ],
      website_link: "https://svpjc.in/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Hactoberfest 2022",
      subtitle:
        "Successfully participated and completed Hactoberfest Challenge",
      logo_path: "hactoberfest.jpg",
      certificate_link: "https://www.holopin.io/@harshilshah99#",
      alt_name: "AWS",
      color_code: "#ffc475",
    },
    {
      title: "D.J. Sanghvi Hackathon",
      subtitle: "We were in top 10 teams at HackNiche",
      logo_path: "hackathon.jpg",
      certificate_link:
        "https://drive.google.com/file/d/14oU1MfDblynnbIol7lSX04efJIYv1W5e/view?usp=sharing",
      alt_name: "AWS",
      color_code: "#ffc475",
    },
    {
      title: "K.J. Somaiya Hackathon",
      subtitle: "We were in top 10 teams at KJSCE Hack 6.0",
      logo_path: "hackathon.jpg",
      certificate_link:
        "https://drive.google.com/file/d/107lP48dLxPzbLfrge3u7RQwSsB-o-gG7/view?usp=sharing",
      alt_name: "Google",
      color_code: "#ffc475",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Internship and Volunteership",
  description:
    "I've completed two internships. I've mostly done projects on my own and I am actively looking for internships. I love organizing workshops to share my knowledge with others.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Internships",
      experiences: [
        {
          title: "Summer Analyst Intern",
          company: "Citi",
          company_url: " ",
          logo_path: "citi.jpg",
          duration: "May 2023 - July 2023",
          location: "Pune",
          description:
            "Added a functionality in an EUC product that introduced an automated bulk data insertion functionality into an Oracle SQL database. Demonstrated expertise in utilizing technologies such as Angular, TypeScript, Oracle SQL, and NodeJs/Express Ensured implementing robust data validation and maintaining data integrity throughout the process.",
          color: "#0071C5",
        },
        {
          title: "Technical Content Writer",
          company: "GeeksforGeeks",
          company_url:
            "https://drive.google.com/file/d/1SxwcJnnThaPogNfuCtjNxAutEB51ThiR/view",
          logo_path: "gfg.jpg",
          duration: "Oct 2022 - Jan 2023",
          location: "Work From Home",
          description:
            "As a Technical Conent Writer I have written over 30+ articles - GeeksforGeeks in the Technical Sripter Event(2022) related to Javascript, HTML, CSS, SASS, Bootstrap 5.",
          color: "#0071C5",
        },
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Technical Head",
          company: "Digital VJTI",
          company_url: " ",
          logo_path: "digital.jpg",
          duration: "Dec 2022 - Sep 2023",
          location: " ",
          description:
            "We have developed the official website of Digital VJTI - https://socialgroup.vjti.ac.in",
          color: "#4285F4",
        },
        {
          title: "Core Team Member",
          company: "Community Of Coders VJTI",
          company_url: " ",
          logo_path: "coc.jpg",
          duration: "Sep 2022 - Oct 2023",
          location: " ",
          description:
            "I have mentored over 3 teams(12+ students) and helped them in building their web dev projects.",
          color: "#D83B01",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create WebDev projects. Below are some of my projects.",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "hrishi2.png",
    description:
      "You can contact me at the places mentioned below. I will try to get back to you as fast as I can. ",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I don't blog frequently but when I do something awesome, I do try my best to write a blog about it.",
    link: "https://medium.com/@hrishipatel99",
    avatar_image_path: "blogs_image.svg",
  },
};

const projects = {
  data: [
    {
      name: "QuickBill",
      url: "https://github.com/harshilshah99/QuickBill",
      description:
        "Simplifying your billing process so that you can shop hassle free!",
      languages: [
        {
          name: "React.js",
          iconifyClass: "logos-react",
        },
        {
          name: "Node.js",
          iconifyClass: "devicon-nodejs",
        },
        {
          name: "Express.js",
          iconifyClass: "devicon-express",
        },
        {
          name: "MongoDB",
          iconifyClass: "logos-mongodb",
        },
        {
          name: "Flutter",
          iconifyClass: "logos-flutter",
        },
        {
          name: "Firebase",
          iconifyClass: "logos-firebase",
        },
      ],
    },
    {
      name: "CodeCollab",
      url: "https://github.com/harshilshah99/Code-Collab",
      description:
        "CodeCollab is a web solution that allows multiple users to code together in real-time.",
      languages: [
        {
          name: "React.js",
          iconifyClass: "logos-react",
        },
        {
          name: "Node.js",
          iconifyClass: "devicon-nodejs",
        },
        {
          name: "Express.js",
          iconifyClass: "devicon-express",
        },
      ],
    },
    {
      name: "WeBlog",
      url: "https://github.com/harshilshah99/WeBlog",
      description:
        "WeBlog is a user-friendly website for creating blogs, featuring an audio option for greater accessibility and a unique recording feature for creating audio content.",
      languages: [
        {
          name: "React.js",
          iconifyClass: "logos-react",
        },
        {
          name: "Node.js",
          iconifyClass: "devicon-nodejs",
        },
        {
          name: "Express.js",
          iconifyClass: "devicon-express",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "MongoDB",
          iconifyClass: "logos-mongodb",
        },
      ],
    },
    {
      name: "greenPaddle",
      url: "https://github.com/harshilshah99/greenPaddle",
      description:
        "greenPaddle is a cycle rental service which offers cycling accessories for purchase, information on cycling routes and much more.",
      languages: [
        {
          name: "Node.js",
          iconifyClass: "devicon-nodejs",
        },
        {
          name: "Express.js",
          iconifyClass: "devicon-express",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "MongoDB",
          iconifyClass: "logos-mongodb",
        },
      ],
    },
    {
      name: "HackTrack",
      url: "https://github.com/harshilshah99/HackTrack",
      description:
        "HackTrack helps in developing innovative solutions that streamline the process od shortlisting teams for hackathons.",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
        {
          name: "React.js",
          iconifyClass: "logos-react",
        },
        {
          name: "Node.js",
          iconifyClass: "devicon-nodejs",
        },
        {
          name: "Express.js",
          iconifyClass: "devicon-express",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "MongoDB",
          iconifyClass: "logos-mongodb",
        },
      ],
    },
  ],
};

export {
  settings,
  greeting,
  socialMediaLinks,
  skills,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
  projects,
};
